export default {"src":"https://fishbrain.com/_next/static/media/sunrise.70ea1d22.svg","height":44,"width":64,"blurWidth":0,"blurHeight":0};